import { useCopy } from "@/hooks/useCopy";

interface ShareButtonProps {
  variant?: "solid" | "ghost";
}

export default function ShareButton({ variant = "solid" }: ShareButtonProps) {
  const { copied, copy } = useCopy();

  const handleShare = () => {
    copy(window.location.href);
  };

  const base =
    "inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors";

  if (variant === "ghost") {
    return (
      <button
        type="button"
        onClick={handleShare}
        className={`${base} border ${
          copied
            ? "border-accent-400 text-accent-300"
            : "border-background-50/30 text-background-100 hover:border-accent-400 hover:text-accent-300"
        }`}
      >
        <i className={copied ? "ri-check-line" : "ri-link"} aria-hidden="true" />
        {copied ? "链接已复制" : "分享链接"}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleShare}
      className={`${base} ${
        copied ? "bg-accent-100 text-accent-700" : "bg-primary-100 text-primary-800 hover:bg-primary-200"
      }`}
    >
      <i className={copied ? "ri-check-line" : "ri-link"} aria-hidden="true" />
      {copied ? "链接已复制" : "分享链接"}
    </button>
  );
}